<!--
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2023-03-16 10:54:50
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2023-03-16 16:03:41
 * @FilePath: /aopumai_pc/src/components/MemberTitles.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
// 个人中心路由切换顶部导航面包屑 @ljp-2021/2/13
<template>
    <div class="member_title_breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="line-height: 40px;font-size: 10px;">
            <el-breadcrumb-item :to="{path:'/index'}" replace>{{L['首页']}}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{path:'/member/connection/connection'}" replace v-if="!memberTitle_two">客户</el-breadcrumb-item>
            <el-breadcrumb-item v-if="memberTitle_two&&!memberTitle_two_path">{{ memberTitle_two }}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{path:memberTitle_two_path}" replace v-if="memberTitle_two&&memberTitle_two_path">{{ memberTitle_two }}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="memberTitle&&memberTitle_path" :to="{path:memberTitle_path}" replace>{{memberTitle}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="memberTitle&&!memberTitle_path">{{memberTitle}}</el-breadcrumb-item>
            <el-breadcrumb-item v-if="memberTitle_o">{{memberTitle_o}}</el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
<script>
    import { getCurrentInstance } from "vue"
    import { elBreadcrumb, elBreadcrumbItem } from "element-plus";
    export default {
        name: 'MemberTitle',
        components: {
            elBreadcrumb,
            elBreadcrumbItem,
        },
        props: ["memberTitle",'memberTitle_o','memberTitle_path','memberTitle_two','memberTitle_two_path'],
        setup() {
            const { proxy } = getCurrentInstance();
            const L = proxy.$getCurLanguage();
            return {
                L
            }
        }
    }
</script>
<style lang="scss">
    .member_title_breadcrumb {
        padding-left: 10px;

        .el-breadcrumb__item {
            height: 46px;
            line-height: 46px;
        }

        .el-breadcrumb__inner {
            color: #666666 !important;
            font-weight: 700 !important;
            font-size: 13px;
        }

        .is-link {
            color: #666666 !important;
            font-weight: 400 !important;

            &:hover {
                color: #333333 !important;
                font-weight: 700 !important;
            }
        }
    }
</style>